<img [attr.src]="formControl.value" class="bloomen-preview">

<mat-form-field>
  <input matInput [formControl]="formControl">
</mat-form-field>
